import { forwardRef } from "react";
import type { ButtonHTMLAttributes, ReactNode } from "react";
import "./Chip.css";

export interface ChipProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  active?: boolean;
  leftIcon?: ReactNode;
  rightIcon?: ReactNode;
  onRemove?: () => void;
}

const cx = (...classes: Array<string | false | undefined>) => classes.filter(Boolean).join(" ");

const CloseIcon = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M6 6l12 12M18 6L6 18" />
  </svg>
);

export const Chip = forwardRef<HTMLButtonElement, ChipProps>(function Chip(
  {
    active = false,
    leftIcon,
    rightIcon,
    onRemove,
    className,
    children,
    disabled,
    type = "button",
    ...rest
  },
  ref,
) {
  return (
    <button
      ref={ref}
      type={type}
      aria-pressed={active || undefined}
      disabled={disabled}
      className={cx(
        "go4-chip",
        active && "go4-chip--active",
        disabled && "go4-chip--disabled",
        className,
      )}
      {...rest}
    >
      {leftIcon ? <span aria-hidden="true">{leftIcon}</span> : null}
      <span>{children}</span>
      {onRemove ? (
        <span
          role="button"
          aria-label="Remove"
          tabIndex={-1}
          className="go4-chip__close"
          onClick={(event) => {
            event.stopPropagation();
            onRemove();
          }}
        >
          <CloseIcon />
        </span>
      ) : rightIcon ? (
        <span aria-hidden="true">{rightIcon}</span>
      ) : null}
    </button>
  );
});
